import { render, staticRenderFns } from "./MedicalTripVoucherList.vue?vue&type=template&id=0cf584a6"
import script from "./MedicalTripVoucherList.vue?vue&type=script&lang=js"
export * from "./MedicalTripVoucherList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports